export default {
  'site-title': "Super-vision, la 1era marketplace del óptica",
  'entete': "Distribución de la óptica:<br><b>¿lista para la revolución?</b><h2>Estamos orgullosos de anunciar el lanzamiento del primer Markeplace de la óptica en Francia.</h2>",
  'demande-information': "Petición de información",
  'plaquette-pdf': "Folleto (pdf)",
  'communique-presse-pdf': "Comunicado de prensa (pdf)",
  'contacter-nous': "<a href=\"mailto:marketplace@super-vision.eu?subject=Marketplace\"><strong>Póngase en contacto con nosotros</strong></a> para obtener más información.",
  'presentation': "<p>Su objetivo # 1 es desarrollar sus ventas?<br> Supervision pone a los fabricantes y proveedores en contacto directo con los ópticos. <br> Gestionamos la comunicación y contribuimos al reclutamiento de sus nuevos clientes y su lealtad.</p><h1 class=\"marg_t15\">SUPERVISION presenta la 1era Marketplace del óptica</h1>",
  'sans-abo': "<h2>SIN SUSCRIPCIÓN</h2><p>alcanzan más de 10.000 clientes <br> en un solo clic</p>",
  'experience': "<h1 class=\"left\">7</h1><p class=\"left\"><strong>AÑOS</strong><br> de experiencia<br> en e-Commerce</p>",
  'nb-client': "<h1><span style=\"font-size: 90px; line-height: 0.6em; font-weight: 600;\">+</span><br><span class=\"right\">10 000</span></h1><p class=\"right\"><strong>ópticos ya clientes</strong></p>",
  'nb-commande': " <h1><span style=\"font-size: 90px; line-height: 0.6em; font-weight: 600;\">+</span><br><span class=\"right\">700</span></h1><p class=\"right\"><strong>pedidos / día</strong></p>",
  'revolution': "<h2>Con vosotros</h2><p>La revolución de la óptica está en progreso!</p>",
  'nouveau-canal': "<h2>UN NUEVO CANAL</h2><p>distribución adicional: gestionar sus pedidos, confirmar envíos y comunicarse con sus clientes.</p>",
  'plateforme': "<h2>ACCEDE A UNA PLATAFORMA EN EL QUE MOSTRAR SUS PRODUCTOS</h2><p>acciones y políticas comerciales de forma rápida y eficiente. En pocos días, empezarás a hacer ventas.</p>",
  'reference': "<h2>ESTANDO REFERENCIADO</h2><p>con Supervisión es una garantía de calidad, seriedad y de saber hacer. <br><strong>Ofrecer, vender, confiar!</strong></p>",
  'autonomie': "<h2><strong>AHORRE TODA LA AUTONOMÍA</strong> <br> DE SU POLÍTICA COMERCIAL</h2><p>de acuerdo con sus objetivos y su estrategia comercial, usted decide en qué mercados desea estar presente: su libertad es TOTAL.</p>",
  'simple-intuitif': "<h1>SIMPLE E INTUITIVO</h1><div class=\"ligne\"></div><p>La Marketplace B2B Supervision es desarrollada por especialistas en la creación de plataformas de intercambio. Las tecnologías que utilizamos son únicas y de vanguardia para garantizar una experiencia fácil de usar y fácil de usar. Una experiensa facil de utilizar.</p>",
  'unique': "<h1>ÚNICO EN FRANCIA</h1><div class=\"ligne\"></div><ul class=\"bullets\"><li>Nuestros clientes se convierten en sus clientes.</li><li>Comunicarse con más de 10.000 ópticas en un solo clic.</li><li>Prueba sus ofertas y su comunicación.</li></ul>",
  'garantie': "<h1>Garantizamos una autonomía perfecta en su política comercial:</h1><div class=\"ligne\"></div><ul class=\"bullets\"><li>Seleccione los productos que desea consultar en Supervision.</li><li>Establezca sus precios de venta en cualquier momento.</li><li>Aplique su propia política de marketing y promociones.</li></ul>",
  'rejoignez-maintenant': "<h1>Únete a la distribución <br> óptica BtoB de mañana.</h1><p>Para más información, rellene el formulario de información.</p><em>(<span class=\"textrouge\">*</span>) campo obligatorio.</em>",
  'info-contact': "Su información de contacto",
  'nom': "Apellido",
  'prenom': "Nombre",
  'telephone': "Telefono",
  'email': "E-mail",
  'raison-sociale': "Empresa",
  'info-societe': "Información de la empresa",
  'adresse': "Número y calle",
  'code-postal': "Código postal",
  'ville': "Cuidad",
  'pays': "Pais",
  'domaine-activite': "Actividades",
  'marques-concernees': "Marcas interesadas",
  'pays-expedition': "Su país de expediciónSu",
  'envoyer': "Enviar",
  'copyright': "Copyright © 2017 <strong>Super-vision</strong>. All rights reserved. Build by <a href=\"http://www.boostup.fr\" target=\"_blank\"><strong>Boostup</strong></a>",
  'categories-produit': "Categorías de productos",
  'compteur': "La revolución comienza en",
  'jours': "días",
  'heures': "horas",
  'minutes': "min",
  'secondes': "&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;sec",
  'verre': "Lentes oftálmicas",
  'montures': "Monturas",
  'montures_solaires': "Gafas de sol",
  'lentilles': "Lentillas de contacto",
  'solutions': "Soluciones de mantenimiento ",
  'instruments_optique_mesure': "Instrumentos ópticos",
  'basse_vision': "Baja Visión",
  'accessoires_lunettes': "Accesorios para monturas",
  'materiel_outillage': "Instrumentos",
  'montage_reparation': "Reparación",
  'informatique': "Informático",
  'agencement_magasin': "Equipamiento y Mobiliario Comercial",
  'services': "Servicios",
  'autres': "Otros",
  'success': "Send successfully, thank you for your confidence !",
  'error': "Oops! An error has occurred please try again later.",
  'invalide': "Please fill in all required fields"
};


// WEBPACK FOOTER //
// ./src/traduction/es.ts